import { createPageEntryPoint } from '@atlassian/jira-create-route-entry-point/src/index.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { polarisProductEAPSettingsEntryPoint } from '@atlassian/jira-spa-apps-polaris-settings-early-access-features/entrypoint.tsx';

export const polarisProductEAPSettingsPageEntryPoint = createPageEntryPoint({
	main: polarisProductEAPSettingsEntryPoint,
	topNavigationMenuId: MENU_ID.SETTINGS,
});
